import type { IconProps } from '.';

/**
 * Sounds On Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const SoundsOnIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0249 9.98754C15.7125 9.36269 15.2589 8.81916 14.7 8.4L15.3 7.6C15.9831 8.11231 16.5375 8.77662 16.9193 9.54033C17.3012 10.304 17.5 11.1462 17.5 12C17.5 12.8538 17.3012 13.696 16.9193 14.4597C16.5375 15.2234 15.9831 15.8877 15.3 16.4L14.7 15.6C15.2589 15.1808 15.7125 14.6373 16.0249 14.0125C16.3373 13.3876 16.5 12.6986 16.5 12C16.5 11.3014 16.3373 10.6124 16.0249 9.98754Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7135 8.3368C19.1672 7.1929 18.3719 6.18567 17.3859 5.38889L18.0145 4.61111C19.1164 5.50163 20.0053 6.62735 20.6158 7.90584C21.2264 9.18432 21.5433 10.5832 21.5433 12C21.5433 13.4168 21.2264 14.8157 20.6158 16.0942C20.0053 17.3726 19.1164 18.4984 18.0145 19.3889L17.3859 18.6111C18.3719 17.8143 19.1672 16.8071 19.7135 15.6632C20.2598 14.5193 20.5433 13.2677 20.5433 12C20.5433 10.7323 20.2598 9.48071 19.7135 8.3368Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.55556 8H2V16H6.55556L11 21V3L6.55556 8ZM10 5.6302L7.00462 9H3V15H7.00462L10 18.3698V5.6302Z"
      fill="white"
    />
  </svg>
);

export default SoundsOnIcon;
